<template>
	<section class="content-wrapper">
		<router-link to="/" exact class="btn btn-back">
			<img
				src="images/chevron-left-green.svg"
				style="margin-right: 6px"
			/>powrót
		</router-link>

		<h1>moje dane</h1>

		<form @submit.stop.prevent="save()">
			<panel-basic-data
				:countries="dictCountries"
				:documentsType="dictDocumentsType"
			/>

			<panel-contact-data
				:countries="dictCountries"
				:provinces="dictProvince"
				@updateAbroadTaxPlace="updateAbroadTaxPlace()"
			/>

			<panel-resident-statement
				:taxCities="dictTaxCities"
				:taxAddresses="dictTaxAddresses"
				:otherTaxCountries="dictCountries"
				ref="PanelResidentStatment"
			/>
			<panel-agreements />
			<panel-statements />
			<br />
			<label style="font-size: 16px"
				>Jeśli chcesz zmienić inne dane skontaktuj się z nami.</label
			>
			<label style="font-size: 16px"
				>Jeśli chcesz zmienić dokument tożsamości na mObywatela prosimy
				o wizytę w Punkcie Usług Maklerskich w Warszawie na ul. Prosta
				18.</label
			>
			<br />
			<br />
			<button type="submit" class="btn btn-primary" :disabled="loader">
				<span v-if="loader" class="loader-button"></span>
				Zapisz zmiany
			</button>
			<br />
			<br />
		</form>
		<router-link
			to="/"
			v-if="windowWidth < mobileBreakpoint"
			exact
			class="btn btn-secondary"
			>Powrót</router-link
		>
	</section>
</template>

<script>
import { getDictionaryItem } from '@/mixins/get-dictionary-item';
import { getMyFx } from '@/mixins/get-my-fx';
import { mapGetters } from 'vuex';

import PanelBasicData from '@/views/myFx/partial/_PanelBasicData';
import PanelContactData from '@/views/myFx/partial/_PanelContactData';
import PanelResidentStatement from '@/views/myFx/partial/_PanelResidentStatement';
import PanelAgreements from '@/views/myFx/partial/_PanelAgreements';
import PanelStatements from '@/views/myFx/partial/_PanelStatements';

import 'vue-datepicker-next/index.css';

export default {
	data() {
		return {
			loader: false,
		};
	},
	components: {
		PanelBasicData,
		PanelContactData,
		PanelResidentStatement,
		PanelAgreements,
		PanelStatements,
	},
	mixins: [getDictionaryItem, getMyFx],
	methods: {
		save() {
			this.loader = true;
			let checkNotSelected =
				this.$store.getters.getMyFx &&
				this.$store.getters.getMyFx.correspondAddress.countryId
					? this.$store.getters.getMyFx.correspondAddress.countryId
					: 160;
			if (checkNotSelected === 160) {
				this.$store.commit('setCorrespondanceAddressCountryId', 160);
			}

			this.$store
				.dispatch('postMyFx')
				.then(
					() => {
						this.$store.commit('setGlobalErrorMessage', '');
						this.$store.commit(
							'setGlobalSuccessMessage',
							'Poprawnie zapisano dane'
						);
						this.$router.push('/MyFx');
					},
					(e) => {
						/* TODO, może jakaś jedna funkcja zczytująca errory dla każdej 400 */
						if (e.status === 400) {
							if (
								typeof e.data !== typeof undefined &&
								typeof e.data.errors !== typeof undefined
							) {
								var errors = e.data.errors;
								var msg = '';
								for (const key of Object.keys(errors)) {
									msg += errors[key] + '<br>';
								}
								this.$store.commit(
									'setGlobalErrorMessage',
									msg
								);
							}
						} else if (e.status === 401) {
							this.$store.commit('setGlobalErrorMessage', '');
							this.$store.commit('setGlobalSuccessMessage', '');
						} else if (e.validation) {
							this.$store.commit(
								'setGlobalErrorMessage',
								e.validation
							);
							this.$store.commit('setGlobalSuccessMessage', '');
						} else {
							this.$store.commit(
								'setGlobalErrorMessage',
								'Bład aplikacji, skontaktuj się z dostawcą'
							);
							this.$store.commit('setGlobalSuccessMessage', '');
						}
						window.scroll({
							top: 0,
							left: 0,
							behavior: 'smooth',
						});
					}
				)
				.finally(() => {
					this.loader = false;
				});
		},
		updateAbroadTaxPlace() {
			this.$store.dispatch('changeTaxCountry').then(() => {
				this.$refs.PanelResidentStatment.filterAddresses(705);
			});
		},
	},
	computed: {
		dictDocumentsType() {
			return this.$store.getters.getDocumentsType
				? this.$store.getters.getDocumentsType
				: [];
		},
		dictCountries() {
			return this.$store.getters.getCountries
				? this.$store.getters.getCountries
				: [];
		},
		dictProvince() {
			return this.$store.getters.getProvince
				? this.$store.getters.getProvince
				: [];
		},
		dictTaxCities() {
			return this.$store.getters.getTaxCities
				? this.$store.getters.getTaxCities
				: [];
		},
		dictTaxAddresses() {
			return this.$store.getters.getTaxAddresses
				? this.$store.getters.getTaxAddresses
				: [];
		},
		windowWidth() {
			return this.$store.getters.getWindowWidth;
		},
		...mapGetters({ mobileBreakpoint: 'getMobileBreakpoing' }),
	},
	async beforeMount() {
		await Promise.all([
			this.$store.dispatch('fetchMyFx'),
			this.$store.dispatch(
				'fetchLogOutTimer',
				this.$store.getters.getTimeToLogout
			),
			this.$store.dispatch('fetchAddressDictionary'),
			this.$store.dispatch('fetchTaxDictionary'),
		]);
	},
};
</script>
